module.exports = __webpack_public_path__ + "img/heroimage.78e87e4d.png";